import { Box, Card, Typography } from '@mui/material'
import { STARTSurveyDisplay } from '../../../../customComponents/survey/STARTSurveyDisplay'
import { useParams } from 'react-router-dom'
import { SurveyType } from '../../../../../models/SurveySchema'

export function MidYear (): JSX.Element {
  const { planId } = useParams()
  const annualPlanId = planId != null ? Number(planId) : 0

  return (
    <Card sx={{
      backgroundColor: 'var(--grey-100)',
      borderRadius: '12px',
      padding: '20px 40px 40px 40px',
      display: 'flex',
      flexDirection: 'column',
      gap: '40px',
      position: 'relative',
      overflow: 'visible'
    }}
      data-testid='midYearReportCard'
    >

      <Box display='flex' flexDirection='column' gap='1em'>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant='h1'>Progress Reports</Typography>
        </Box>

        <Typography variant='body1'>
          Share information about your progress toward your Implementation Plan with START at Mid-Year and End of Year by completing the Progress Reports.
        </Typography>

        <Box sx={{
          display: 'flex',
          padding: '24px 40px 40px 40px',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
          gap: '28px',
          alignSelf: 'stretch',
          borderRadius: '8px',
          border: '1px solid var(--Theme-primitive-primary-300, #5499C3)',
          background: 'var(--Base-Tones-primitive-surface-100, #FFF)',
          boxShadow: '0 1px 0px 0 rgba(37, 36, 38, 0.08), 0 2px 3px -1px rgba(37, 36, 38, 0.08)'
        }}
        >
          <STARTSurveyDisplay annualPlanId={annualPlanId} surveyType={SurveyType.MidYear}/>
        </Box>
      </Box>
    </Card>
  )
}
